import { attribute, entity, meta, JsonapiEntity } from 'jsonapi-transformers';

export enum UserJobRoleDescription {
  ACADEMIC = 'academic',
  TEACHER = 'teacher',
  LECTURER = 'lecturer',
  EDUCATIONAL_SUPPORT = 'educational_support',
  UNDERGRADUATE = 'undergraduate',
  POSTGRADUATE = 'postgraduate',
  RESEARCHER = 'researcher',
  LIBRARIAN = 'librarian',
  LEARNING_TECHNOLOGIST = 'learning_technologist',
  NON_TEACHING_FACULTY = 'non_teaching_faculty',
}

@entity({ type: 'users' })
export class UserRecord extends JsonapiEntity {
  @attribute() first_name: string;
  @attribute() surname: string;
  @attribute() email: string;
  @attribute() job_role_description?: UserJobRoleDescription;
  @meta({ name: 'devolved_authorisations' })
  devolvedAuthorisations?: string[];

  // derived properties
  get full_name(): string {
    if (this.first_name && this.surname) {
      return `${this.first_name} ${this.surname}`;
    }
    return undefined;
  }
}
